import { Badge, Box, DataList, Flex, Text, Tooltip } from '@radix-ui/themes'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { appConfig } from '~/app-config.ts'
import { ProductAddToCart } from '~/components/common/product-add-to-cart'
import { ProductCollapse } from '~/components/common/product-collapse'
import { ProductName } from '~/components/common/product-name'
import { Price } from '~/components/ui/price'
import { type GetProductOption } from '~/models/ecommerce-providers/sylius/shop/fetch/product-option/get-product-option'
import { type GetProductOptionValue } from '~/models/ecommerce-providers/sylius/shop/fetch/product-option-value/get-product-option-value'
import { type ProductNormalized } from '~/models/ecommerce-providers/sylius/shop/interface/product'
import { type ProductVariantNormalized } from '~/models/ecommerce-providers/sylius/shop/interface/product-variant'
import { type Locale } from '~/models/locale'
import { ProductOptions } from '~/routes/($lang).products.$slug/product-options'
import { PRODUCTS_SLUG_I18NEXT } from '~/routes/($lang).products.$slug/slug.component'

/* -------------------------------------------------------------------------------------------------
 * ProductSidebar
 * -----------------------------------------------------------------------------------------------*/

type ProductSidebarProps = {
	className?: string
	product: ProductNormalized
	variant: ProductVariantNormalized
	searchParams: URLSearchParams
	locale: Locale
}

const ProductSidebar: React.FC<ProductSidebarProps> = ({
	product,
	locale,
	variant,
	searchParams,
}) => {
	const { t } = useTranslation(PRODUCTS_SLUG_I18NEXT.routeProductsSlug)

	return (
		<>
			<Flex direction="column" gapY="6" mt="5">
				<ProductName
					size={{
						initial: '6',
						xs: '7',
					}}
          weight="medium"
				>
          {variant.name || product.name!}
        </ProductName>
        <DataList.Root>
          <DataList.Item align="center">
            <DataList.Label minWidth="88px">{t('common.manufacturer')}</DataList.Label>
            <DataList.Value>
              {product.manufacturer}
            </DataList.Value>
          </DataList.Item>
          {Object.entries(product.properties)?.map(([key, value]) => (
            <DataList.Item key={key} align="center">
              <DataList.Label minWidth="88px">{key}</DataList.Label>
              <DataList.Value>
                {value}
              </DataList.Value>
            </DataList.Item>
          ))}
        </DataList.Root>
			</Flex>
		</>
	)
}
ProductSidebar.displayName = 'ProductSidebar'

/* -----------------------------------------------------------------------------------------------*/

export { ProductSidebar }
